import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Homepage from './components/screens/Homepage';
import Login from './components/screens/Login';


function App() {
  return (
    <Router>
    <div className="app">
      <Routes>
        <Route exact path="/" element={<Login/>} />
        <Route path="/home" element={<Homepage/>} />
      </Routes>
    </div>
  </Router>
  );
}

export default App;
